import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import t from '../../lib/I18n';
import usePrevious from '../../hooks/usePrevious';

import ShowPasswordIcon from '../icons/ShowPasswordIcon';

const ShowPassword = ({ active, onClick }) => {
    const showPasswordLabel = t('customerdetails.password.show');

    let title, status;
    if (active) {
        title = t('customerdetails.password.hide');
        status = t('customerdetails.password.shown');
    } else {
        title = showPasswordLabel;
        status = t('customerdetails.password.hidden');
    }

    const previous = usePrevious(active);
    const changed = !_.isNil(previous) && previous !== active; // do not announce initial state

    return (
        <React.Fragment>
            <button
                type="button"
                className="show-password"
                onClick={onClick}
                title={title}
                aria-pressed={Boolean(active)}
                aria-label={showPasswordLabel}
            >
                <ShowPasswordIcon active={active} />
            </button>
            {changed && (
                <div role="status" className="sr-only" aria-hidden="true">
                    {status}
                </div>
            )}
        </React.Fragment>
    );
};

ShowPassword.propTypes = {
    active: PropTypes.bool,
    onClick: PropTypes.func
};

ShowPassword.defaultProps = {
    active: false,
    onClick: _.noop
};


export default ShowPassword;



// WEBPACK FOOTER //
// ./src/components/form/ShowPassword.js